 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {HocuspocusProvider, HocuspocusProviderWebsocket} from '@hocuspocus/provider'
import {IndexeddbPersistence} from 'y-indexeddb'
import * as Y from 'yjs'


class ProviderManager {constructor() { ProviderManager.prototype.__init.call(this);ProviderManager.prototype.__init2.call(this); }
  __init() {this.socket = undefined}
  __init2() {this.providers = {}}
  
  setAtmosphere(atmosphere) {
    this.atmosphere = atmosphere
  }
  getSocket() {
    if (!this.socket) {
      const wsProtocol = window.location.protocol.replace('http', 'ws')
      const url = `${wsProtocol}//${window.location.host}/yjs`
      this.socket = new HocuspocusProviderWebsocket({
        url
      })
    }
    return this.socket
  }
  use(documentName) {
    const existing = this.providers[documentName]
    if (existing) {
      existing.count++
      return existing.provider
    }
    return null
  }
  register(documentName) {
    const existing = this.use(documentName)
    if (existing) return existing
    const doc = new Y.Doc()
    // update the URL to match the title
    const provider = new HocuspocusProvider({
      websocketProvider: this.getSocket(),
      name: documentName,
      document: doc,
      onAuthenticationFailed: ({reason}) => {
        if (reason === 'Unauthenticated') {
          _optionalChain([this, 'access', _ => _.atmosphere, 'optionalAccess', _2 => _2.invalidateSession, 'call', _3 => _3(reason)])
        }
      }
    })
    provider.attach()
    this.providers[documentName] = {count: 1, provider}
    if (documentName.startsWith('page:')) {
      // this adds support for offline editing
      new IndexeddbPersistence(documentName, doc)
    }
    return provider
  }
  unregister(documentName, delay = 10000) {
    const prevProviderEntry = this.providers[documentName]
    if (!prevProviderEntry) return
    if (--prevProviderEntry.count === 0) {
      setTimeout(() => {
        this.destroy(documentName)
      }, delay)
    }
  }

  async withDoc(documentName, callbackFn) {
    const provider = this.register(documentName)
    const callAndComplete = async () => {
      const {document} = provider
      await callbackFn(document)
      this.unregister(documentName)
    }
    if (provider.synced) {
      callAndComplete()
    } else {
      provider.on('synced', callAndComplete)
    }
  }

  destroy(documentName) {
    const prevProviderEntry = this.providers[documentName]
    if (!prevProviderEntry) return
    if (prevProviderEntry.count === 0) {
      prevProviderEntry.provider.destroy()
      delete this.providers[documentName]
    }
  }

  close() {
    Object.values(this.providers).forEach((p) => p.provider.destroy())
    this.providers = {}
  }
}

export const providerManager = new ProviderManager()
